// What a row's menu (components/ChannelRowMenu.tsx) adds around the notification menu (NotifyMenu: Mute and the
// levels), without React: which items show for a row, and the link. Plain functions, so scripts/row-menu-cases.mjs
// can test them without a browser. The order is the same on every platform (the iOS app's row menu follows it):
// Mark as read, Mute, Notifications, Copy link, Channel settings…, Close conversation.

/** Items before the mute (`before`) and after the levels (`after`), in order. */
export type RowAction = "read" | "link" | "settings" | "close";

export interface RowMenuFacts {
  kind: "text" | "dm";
  /** Messages after my read position, or unread mentions. Mute hides the dot, but not this. */
  hasUnread: boolean;
  /** I am an owner or an admin of the server. */
  canEditChannels: boolean;
  /** The row has a close (a DM of the open server). */
  canClose: boolean;
}

export function rowActions(f: RowMenuFacts): { before: RowAction[]; after: RowAction[] } {
  return {
    before: f.hasUnread ? ["read"] : [],
    after: ["link", ...(f.kind === "text" && f.canEditChannels ? (["settings"] as const) : []), ...(f.kind === "dm" && f.canClose ? (["close"] as const) : [])],
  };
}

/** The link to a conversation on this origin. */
export const channelUrl = (origin: string, serverId: string, channelId: string): string => `${origin}/s/${serverId}/${channelId}`;
